import { render } from "./TSAVideoPanel.vue?vue&type=template&id=340c6bbe&scoped=true"
import script from "./TSAVideoPanel.vue?vue&type=script&lang=js"
export * from "./TSAVideoPanel.vue?vue&type=script&lang=js"

import "./TSAVideoPanel.vue?vue&type=style&index=0&id=340c6bbe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340c6bbe"]])

export default __exports__